import type { Category } from '@vsf-enterprise/commercetools-types';
import { CATEGORY_CUSTOM_FIELDS } from '~/constants/commerceTools';
import { extractCustomField } from '~/helpers/customFields';

export function getCategoryImgUrl(category: Category): string | undefined {
  return extractCustomField(category, CATEGORY_CUSTOM_FIELDS.IMG_URL);
}
